// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__oJq2y"};